import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Col, Tree } from 'antd';
import { FolderOpenOutlined, CheckOutlined, SearchOutlined, SkinOutlined, StarOutlined } from '@ant-design/icons';
import { isEqual, debounce, cloneDeep } from 'lodash';
import { callApi } from 'utils';
import { SelectContext } from '../context';
const TreeNode = Tree.TreeNode;

class SelectLevel extends Component {
	static contextType = SelectContext;
	constructor (props) {
		super(props);
		this.state = {
			loading: true,
			disabledObj: this.getDisabledObj(props.disabledSelects),
			treeNodes: [],
			searchList: [],
			levelGroups: [],
			expandedKeys: [],
			selectedKeys: [],
		};
	}

	componentDidMount () {
		this.initList(this.props);
	}

	componentWillReceiveProps (nextProps) {
		const {organizations} = this.props;
		const {selects} = nextProps;
		if (organizations !== nextProps.organizations && nextProps.organizations) {
			this.initList(nextProps);
		}
		if (!isEqual(this.props.selects, selects)) {
			this.setState({
				selectedKeys: selects.filter(val => val.flowUserSelectionType === 'level').map(val => String(val.sourceIdA))
			});
		}
	}
  //封装已选择列表
  getSelectObj = (selects = []) => {
  	let obj = {};
  	selects.filter(val => val.flowUserSelectionType === 'level').forEach(val => {
  		obj[String(val.sourceIdA)] || (obj[String(val.sourceIdA)] = true);
  	});
  	return obj;
  }
  //封装不可选择列表
  getDisabledObj = (disabledList = []) => {
  	let obj = {};
  	disabledList.filter(val => val.flowUserSelectionType === 'level').forEach(val => {
  		obj[String(val.sourceIdA)] || (obj[String(val.sourceIdA)] = true);
  	});
  	return obj;
  }
	/**
	 * 获取岗位
	 */
	initList = (props) => {
		this.setState({
			loading: true
		});
		const {organizations} = props;
		const { manageSceneFlag } = this.context;
		let api = '/org_v6/listJobLevelGroups';
		let data = {
			organizationId: organizations.id,
			manageSceneFlag
		};
		callApi({
			api,
			data,
			success: (levelGroups = []) => {
				this.setState({
					treeNodes: this.generateNodes(levelGroups),
					levelGroups,
					expandedKeys: levelGroups.map(obj => (String(obj.id)) + 'group'),
					loading: false,
				});
			}
		});
	}

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = (list) => {
		let { disabledObj } = this.state;
		return list.map(node => {
			const { jobLevels, name, id, selectedFlag, jobLevelGroupId, level, prefix } = node;
			if (jobLevels && jobLevels.length > 0) {
				return <TreeNode
					disabled={disabledObj[id] || selectedFlag === 0}
					selectable={false}
					allData={node}
					key={String(id) + 'group'}
					title={<div>{name}</div>}
				>
					{this.generateNodes(jobLevels)}
				</TreeNode>;
			}
			return <TreeNode disabled={disabledObj[`${prefix}${level}`] || selectedFlag === 0} allData={node} key={`${prefix}${level}`}
				title={jobLevelGroupId ? <div>
					<StarOutlined className='type-icon' />
					{name}
					<CheckOutlined className={'select-modal-checked-icon'}/>
				</div> : name} />;
		});
	}

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		let searchList = [];
		keywords = keywords.trim();
		let {levelGroups = []} = this.state;
		if (!keywords) {
			this.setState({
				searchList: [],
				searchText: keywords,
			});
		} else {
			levelGroups.map(({jobLevels = []}) => {
				searchList = searchList.concat(jobLevels.filter(({name = ''}) => name.toLowerCase().indexOf(keywords.toLowerCase()) > -1));
			});
			this.setState({
				searchList: this.generateList(searchList),
				searchText: keywords,
			});
		}
	}

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = list => {
		let { disabledObj } = this.state;
		return list.map(node => {
			let { name, level, selectedFlag, prefix } = node;
			return <TreeNode disabled={disabledObj[`${prefix}${level}`] || selectedFlag === 0} allData={node} key={`${prefix}${level}`}
				title={<div>
					<StarOutlined className='type-icon' />
					{name}
					<CheckOutlined className={'select-modal-checked-icon'}/>
				</div>}
			/>;
		});
	};

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({ expandedKeys: keys });
	}

	// 选择职级
	onSelect = (selectedKeys, {selectedNodes, node, selected}) => {
		const { props } = this;
		let newSelect = [];
		if (Array.isArray(selectedNodes)) {
			newSelect = selectedNodes.filter(val => val.allData.jobLevelGroupId).map(val => ({
				selectionName: val.allData.name,
				flowUserSelectionType: 'level',
				sourceIdA: `${val.allData.prefix}${val.allData.level}`,
				sourceTypeA: 'source_level',
			}));
			if (selected) {
				props.addItems(newSelect);
			} else {
				props.removeItems(this.getlevelItems(node.allData));
			}
		}
		this.setState({ selectedKeys: selectedKeys });
	}

	//获取标签
	getlevelItems = data => {
		let { levelGroups } = this.state;
		if (data.groupId) {
			return [{
				selectionName: data.name,
				flowUserSelectionType: 'label',
				sourceIdA: data.id,
				sourceTypeA: 'source_label',
			}];
		}
		for (let i in levelGroups) {
			let val = levelGroups[i];
			if (val.id === Number(data.id) && val.labels) {
				return val.jobLevels.map(obj => ({
					selectionName: obj.name,
					flowUserSelectionType: 'level',
					sourceIdA: obj.level,
					sourceTypeA: 'source_level',
				}));
			}
		}
	}

	// 防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	render () {
		const {loading, searchText, dataSource, disabledObj, searchList, selectedKeys, expandedKeys, treeNodes} = this.state;
		return (
			<Col className='tree-box scroll-tree-box'>
				<div className='select-box-search'>
					<Input
						placeholder="请输入职级"
						onChange={(e) => this.searchByKeywordsDebounced(e.target.value)}
						prefix={<SearchOutlined />}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{searchText
						? searchList.length < 1
							? <div className='tree-box-center'>未找到相关结果</div>
							: <Tree
								multiple
								selectedKeys={cloneDeep(selectedKeys)}
								onSelect={this.onSelect}
								selectable
							>
								{searchList}
							</Tree>
						: <Tree
							multiple
							expandedKeys={cloneDeep(expandedKeys)}
							selectedKeys={cloneDeep(selectedKeys)}
							onExpand={this.onExpand}
							onSelect={this.onSelect}
							selectable
						>
							{treeNodes}
						</Tree>
					}
				</div>
			</Col>
		);
	}
}

SelectLevel.propTypes = {
	// 组织架构数据
	organizations: PropTypes.object.isRequired,
	organizationId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),

	/* 以下是configs额外传进来的参数 */
	// 扩展的树节点，格式为 [{id: -1, name: '不限部门', type: 'source_unlimited_department', childrens: [...]}]
	extendTree: PropTypes.array,
	disabledSelects: PropTypes.array,
	selects: PropTypes.array,
	addItems: PropTypes.func.isRequired,
	removeItems: PropTypes.func.isRequired,
};

export default SelectLevel;
